import styled from 'styled-components';

export default styled.video`
  display: ${props => props.hide ? 'none' : 'inherit'};
  width: ${props => props.isResponsive ? 'auto' : '100%'};
  height: ${props => props.isBackground || props.isResponsive ? '100%' : '100%'};
  position: ${props => props.isBackground ? 'absolute' : 'relative'};
  object-fit: ${props => props.isBackground ? 'cover' : 'contain'};
  
  ${props => !props.isBackground && `
    margin: 0 auto;
    max-width: 190rem;
  `}
`;
